import {getHexKeysInRange} from "../../utils/coords/getHexKeysInRange";
import {FIELD_CENTRAL_HEX_KEY} from "../../constants/field";

export const POLICY_HEGEMONISM_DISTANCE = 2;
export const POLICY_HEGEMONISM_BONUS_HEX_KEYS = getHexKeysInRange(FIELD_CENTRAL_HEX_KEY, POLICY_HEGEMONISM_DISTANCE);

export const POLICY_HEGEMONISM_TEMPLE_WIN_POINTS_INCOME_BONUS = 2;
export const POLICY_HEGEMONISM_QUARTER_WIN_POINTS_INCOME_BONUS = 1;

export const POLICY_HEGEMONISM_MELEE_BONUS = 3;



